import posthog from 'posthog-js'

export const posthogUtil = () => {
  const POSTHOG_APIKEY = import.meta.env.VITE_REACT_APP_POSTHOG_API_KEY
  // Don't do anything in DEV-type env
  if (import.meta.env.DEV) return

  posthog.init(POSTHOG_APIKEY, {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
  })
}
